import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { ViewDetailsPlumitifComponent } from '../view-details-plumitif/view-details-plumitif.component';
import { ViewDetailsRepertoireComponent } from '../view-details-repertoire/view-details-repertoire.component';
import $ from 'jquery';
import {EnrollementService} from "../../services/frapper/enrollement.service";
import {DossierService} from "../../services/frapper/dossier.service";
import {CustomService} from "../../services/frapper/custom.service";
import { ViewDetailsDossierComponent } from '../view-details-dossier/view-details-dossier.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PersonnesService } from '../../services/frapper/personnes.service';
import { AlertesService } from '../../services/public/alertes.service';
import { ChambresService } from '../../services/frapper/chambres.service';
import { AssignedService } from '../../services/frapper/assigned.service';

@Component({
  selector: 'app-view-details-chambre',
  templateUrl: './view-details-chambre.component.html',
  styleUrls: ['./view-details-chambre.component.scss']
})
export class ViewDetailsChambreComponent {

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data:any;
  dossiersChambre: any[] = [];
  internesCourriers: any[] = [];
  internesPrincipals: any[] = [];
  isButtonDisabled: boolean = true;
  @Input() parentModal: BsModalRef;
  pagePlumitifs: number;
  pagerepertoires: number;
  pageDossier: number = 1;
  @ViewChild('myTable', { static: false }) myTable!: ElementRef;
  
  postes = ['PRESIDENT','GREFFIER', 'SUPPLEANT', 'JUGE DE LA MISE EN ETAT','MEMBRE'];

  list_plumitifs: any[] = [
    {
      'numero_de_jugement': 'AR-06-2024',
      'decision_judiciaire': 'report',
      'date_de_jugement': '2024-04-13',
      'node_daudiences': "Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu'il est prêt ou que la mise en page est achevée. Généralement, on utilise un texte en faux latin, le Lorem ipsum ou Lipsum.",
      'nom_complet_plaignant': "Ahmadou Diagne X Moustapha Seye",
      'prenom': "Moustapha ",
      'nom': "Moustapha Seye"
    }
  ]
  list_repertoires: any[] = [
    {
      'jugement_code': 'AR-06-2024',
      'decision_judiciaire': 'report',
      'date_de_decision': '2024-04-13',
      'factum': "Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu'il est prêt ou que la mise en page est achevée. Généralement, on utilise un texte en faux latin, le Lorem ipsum ou Lipsum.",
      'qualites': "Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu'il est prêt ou que la mise en page est achevée. Généralement, on utilise un texte en faux latin, le Lorem ipsum ou Lipsum.",
      'node_daudiences': "Le lorem ipsum est, en imprimerie, une suite de mots sans signification utilisée à titre provisoire pour calibrer une mise en page, le texte définitif venant remplacer le faux-texte dès qu'il est prêt ou que la mise en page est achevée. Généralement, on utilise un texte en faux latin, le Lorem ipsum ou Lipsum.",
      'nom_complet_plaignant': "Ahmadou Diagne X Moustapha Seye",
      'prenom': "Moustapha ",
      'nom': "Moustapha Seye"
    }
  ]
  my_tribunal:any = null

  membres=[]

  CAN_ADD_MEMBRE=false
  profil:any
  getfolder: any
  persons: any[] = [];

  constructor(private _formBuilder: FormBuilder,
              private datePipe: DatePipe,private options: ModalOptions,
              private penalCourrierService: PenalCourrierService,
              private personneService:PersonnesService,
              private customService: CustomService,
              private chambreService: ChambresService,
              private role:EnrollementService,
              private ngxService: NgxUiLoaderService,
              private assigneService: AssignedService,
              private bsModalRef: BsModalRef,
              private alerte: AlertesService,
              private modalService: BsModalService) {
    this.data = this.options.initialState.data;
    this.getfolder = this.options.initialState.folder;
    // this.type = this.options.initialState.type;
    console.log(this.data)
    this.profil =localStorage.getItem('profil')
    this.my_tribunal = JSON.parse(localStorage.getItem('my_tribunal'))
  }





  activePane = 0;

  onTabChange($event: number) {
    this.activePane = $event;
    console.log('onTabChange', $event);
  }

  closeModal(){
    this.bsModalRef.hide()
  }

  async getAllDataOfTheChambre( chambreName: string) {
   //this.dossiersChambre = this.penalCourrierService.searchDossierByChambre(chambreName);
    let result = (await this.customService.getAllInformationsOfChambre(chambreName)).message
    this.dossiersChambre = result.all_dossiers
    this.list_plumitifs = result.audiences
    this.list_repertoires= (result.audiences).filter(objet => (objet.status == 'Decision rendue' || objet.status == 'En appel'||objet.status == 'Definitive'||objet.status == 'Definitive'));
    console.log('the Data', this.dossiersChambre);
  }



  openModalDetailsPlumitif(plumitif: any) {
    const config: ModalOptions = {
      initialState: {
        data: plumitif
      }
     }
     const modalRef = this.modalService.show(ViewDetailsPlumitifComponent, Object.assign({},config,{class:'modal-lg '}));

  }

  openModalDetails(data: any, type:string) {
    // let courrier:any = this.courriers[id];
    // console.log('details === '+ courrier);

    const config: ModalOptions = {
      initialState: {
        data: data,
        type: type
      }
     }
    let modalRef = this.modalService.show(ViewDetailsDossierComponent, Object.assign({},config,{class:'modal-xl '}));

  }

  openModalDetailsRepertoire(plumitif: any) {
    const config: ModalOptions = {
      initialState: {
        data: plumitif
      }
     }
     const modalRef = this.modalService.show(ViewDetailsRepertoireComponent, Object.assign({},config,{class:'modal-lg '}));

  }
  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'dd-MM-yyyy');
  }

  async getPersons(){
     
    this.ngxService.start()
    try {

     this.persons= (await this.personneService.getAllPersonne()).data

    } catch (error) {
     
    }finally{
     this.ngxService.stop()
    }
    
  }

//   extraireDonnees(arr) {
//     console.log('exraireDonnees', arr);
//     return arr.map(obj => ({
//       nom_complet: obj.nom_complet,
//       poste: obj.poste,
//       utilisateur: obj.utilisateur 
//     }));
// }


  async updateDataChambre(data: any = null) {
    let data_table: any[] = [];
    this.ngxService.start()

    data_table = data != null ? data : this.getTableData();

    let membres = {
      "membres": data_table

    }

    console.log('new data:', membres);
    
    await this.chambreService.updateChambre(this.data.name, membres).then(res=>{
      this.ngxService.start()
      this.alerte.successNotification('Chambre','Mise à jour effectuee!')
      console.log('Chambre updated: ', res)
      this.ngxService.stop()
    },err=>{
      this.alerte.errorNotification('Chambre','Erreur lors de la mise a jour du Chambre')
      this.ngxService.stop()
    })

  }
  
  confirmationDialog(type:string,title: string, message: string, item: any) {
    let is_confirmed = false;
   let confirm = this.alerte.ConfirmationDialog(title, message).then(async (result) => {
    if (result) {
      console.log('User clicked OK');
      console.log('parametres ===> ', type, title, message, item);
      is_confirmed =  true;
      const index = this.membres.indexOf(item);
     
      if (index > -1) {
        this.membres.splice(index, 1);
        console.log('index of persons => ', this.membres);
        this.updateDataChambre(this.membres).then(res=>{
          console.log('Membres updated successfully');
          this.assigneService.removeAssignation("Chambres", this.data.name, item.utilisateur)
          this.assigneService.removeReadAuth("Chambres", this.data.name, item.utilisateur)
          
        }
        ).catch(err=>{  
          console.error('Error updating members:', err);
          this.alerte.errorNotification('Chambre', 'Erreur lors de la mise à jour des membres');
        }
        );
      }
      
      
    } else {
      console.log('User clicked Cancel');
      is_confirmed =  false;
    }
  });
   

  }
  deleteItem(type,item){
    this.confirmationDialog(type,'Supprimer ' + type, 'Êtes-vous sûr de vouloir supprimer cette ' + type + ' ?', item);
 }

 getTableData() {
  const tableData = [];

  $('#myTable tbody tr').each(function(index, tr) {
    const nomComplet = $(tr).find('input[name="nom_complet"]').val() || '';
    const utilisateur = $(tr).find('input[name="utilisateur"]').val() || '';
    const poste = $(tr).find('select[name="poste"]').val() || '';

    tableData.push({
      nom_complet: nomComplet,
      utilisateur: utilisateur,
      poste: poste
    });
  });

  console.log('tableData:', tableData); // Vous pouvez afficher ou envoyer ces données
  return tableData;
}
 ngAfterViewInit() {
  // this.recupererDonneesDepuisDOM();
}
  async ngOnInit() {
    this.ngxService.start()
    console.log('the Datakkk', this.getfolder);
    console.log({'inf subs == ':this.data});
    if(this.profil=='GREFFIER EN CHEF' || this.profil=='PRESIDENT DU TRIBUNAL'){
      this.CAN_ADD_MEMBRE=true
    }
    await this.getAllDataOfTheChambre(this.data.name)

    await this.role.getOneChambre(this.data.name).then(res=>{
      this.data =res.data
      this.membres =this.data.membres
    })
    this.getPersons()


    var self = this;
    $('.dropdown-el').click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).toggleClass('expanded');
      $('#'+$(e.target).attr('for')).prop('checked',true);
    });
    $(document).click(function() {
      $('.dropdown-el').removeClass('expanded');
    });

    const optionsHTML = self.postes.map(poste => `<option value="${poste}">${poste}</option>`).join('');

    $('#addRowBtn').on('click', function() {
      // Créez une nouvelle ligne avec des colonnes Bootstrap
      const newRow = '<tr>' +
                      '<td></td>' +
                      //  '<td><input type="text" class="form-control" name="prenom"  /></td>' +
                      '<td><input type="text" class="form-control" name="nom_complet" />' +
                      '<div class="list_item dropdown-menu" style="margin-top:-8%;"><ul style=" cursor: pointer;max-height:200px;overflow: auto;z-index:10;"></ul></div>' + '</td>' +
                       '<td><input type="text" class="form-control" name="utilisateur"  /></td>' +
                      
                       `<td>
                        <select name="poste" id="" class="form-control">
                        ${optionsHTML}
                      </select>
                       </td>` +
                       '<td><i class="fas fa-solid fa-trash text-danger deleteRowBtn_inf" style="font-size: 15px;"></i></td>' 
                     '</tr>'

      // Ajoutez la nouvelle ligne au tableau
      $('#myTable tbody').append(newRow);


      // Cachez les éléments .list_item après l'ajout de la ligne
      $('#myTable tbody tr:last .list_item').hide();

      // Chargez la liste des éléments depuis l'API
      loadListItems($('#myTable tbody tr:last'));

      // Focus sur le champ  pour afficher le dropdown
      $('#myTable tbody tr:last input[name="nom_complet"]').on('focus', function() {
        $(this).closest('tr').find('.list_item').show();
      });

      // Optionnel: Ajouter un gestionnaire de blur pour cacher la liste quand on quitte le champ
      $('#myTable tbody tr:last input[name="nom_complet"]').on('blur', function() {
        // Ajouter un délai pour éviter que la liste se cache immédiatement après la sélection d'un élément
        setTimeout(() => {
          $(this).closest('tr').find('.list_item').hide();
        }, 200);
      });

      // Filtrage de la liste pendant la saisie
      $('#myTable tbody tr:last input[name="nom_complet"]').on('input', function() {
        const searchTerm = $(this).val().toLowerCase(); // Récupérer la valeur en minuscules
        const listItems = $(this).closest('tr').find('.list_item ul li'); // Sélectionner tous les éléments de la liste
        const noMatchSuggestion = $(this).closest('tr').find('.no-match-suggestion');
        const newItemSpan = $(this).closest('tr').find('.new-item');

        let matchFound = false;

        listItems.each(function() {
          const listItemText = $(this).text().toLowerCase();
          if (listItemText.indexOf(searchTerm) === -1) {
            $(this).hide(); // Si le texte ne correspond pas, masquer l'élément
          } else {
            $(this).show(); // Sinon, afficher l'élément
            matchFound = true;
          }
        });

        // Si aucune correspondance n'est trouvée, afficher l'option pour ajouter un élément
        if (!matchFound && searchTerm.trim() !== '') {
          noMatchSuggestion.show();
          newItemSpan.text(searchTerm); // Afficher la saisie de l'utilisateur comme élément suggéré
        } else {
          noMatchSuggestion.hide(); // Cacher l'option d'ajout si une correspondance est trouvée
        }
      });

      // Ajouter un gestionnaire d'événements sur les éléments de la liste pour permettre la sélection
      // $('#myTable tbody').on('click', '.list_item ul li', function() {
      //   const selectedText = $(this).text(); // Récupérer le texte de l'élément sélectionné
      //   $(this).closest('tr').find('input[name="nom_complet"]').val(selectedText); // Mettre à jour la valeur du champ "nom_complet"
      //   $(this).closest('tr').find('.list_item').hide();
      // });
      $('#myTable tbody').on('click', '.list_item ul li', function() {
        const selectedText = $(this).text(); // Récupérer le nom sélectionné
      
        // Rechercher la personne dans le tableau
        console.log('self.persons', self.persons);
        
        const personne = self.persons.find(p => p.name === selectedText);
        console.log('personne trouvée:', personne);
      
        // Référencer la ligne (tr) actuelle
        const $row = $(this).closest('tr');
      
        // Mettre à jour le champ 'nom_complet'
        $row.find('input[name="nom_complet"]').val(selectedText);
      
        // Mettre à jour le champ 'utilisateur' avec l'email si trouvé
        if (personne) {
          $row.find('input[name="utilisateur"]').val(personne.utilisateur);
        } else {
          $row.find('input[name="utilisateur"]').val(''); // Optionnel : vider si non trouvé
        }
      
        // Cacher la liste
        $row.find('.list_item').hide();
      });
      

      // Ajouter le nouvel élément à la liste
      // $('#myTable tbody tr:last .no-match-suggestion').on('click', function() {
      //   const searchTerm = $(this).closest('tr').find('input[name="nature"]').val().trim();
      //   addItemToApi(searchTerm);
      // });

      // delete infraction
      $('#myTable tbody').on('click', '.deleteRowBtn_inf', function() {
        $(this).closest('tr').remove();
      });


            
    });

    // Fonction pour charger les éléments de la liste depuis l'API
      function loadListItems(row) {
        console.log('the infrac', self.persons);
  
        if (self.persons && Array.isArray(self.persons)) {
          self.persons.forEach((item) => {
            // Ajoutez chaque item à la liste dans la ligne spécifiée
            row.find('.list_item ul').append('<li>' + item.name + '</li>');
          });
        } else {
          console.error('Données invalides reçues de l\'API');
        }
      }
  
      // function addItemToApi(itemName) {
  
  
      //   const config: ModalOptions = {
      //     initialState: {
      //       label: itemName,
      //       type: 'infraction'
      //     }
      //   };
  
      //   console.log('openingSuccess');
      //   return new Promise<string>((resolve, reject) => {
      //     self.bsModalRef = self.modalService.show(AddInfractionsComponent, Object.assign({}, config, {class:'modal-lg'}));
      //     self.bsModalRef.content.parentModal = self.bsModalRef;
      //     self.bsModalRef.onHidden.subscribe((value: string) => {
      //       resolve(value); // Résoudre la promesse avec la valeur retournée
      //     });
      //   }).then(async (value: string) => {
      //     console.log('in addinfraction', value);
  
      //     if ( value == "success") {
      //       self.enrole.getAllInfractions().then(res=>{
      //         self.gettedInfractions = res.data
  
      //       })
  
      //     }
  
      //   // self.modalRef = self.modalService.show(AddInfractionsComponent, Object.assign({}, config, {class:'modal-sm'}));
      // })
  
      //   // self.modalRef = self.modalService.show(AddInfractionsComponent, Object.assign({}, config, {class:'modal-sm'}));
      // }
     

    this.ngxService.stop()
  }
}
